import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";
import { AxiosResponse } from "axios";
import {
  IAvailableOffersResponse,
  IOfferSummary,
} from "@/apps/merchant3/models/IDeviceOffer";
import { IOffer } from "@/apps/merchant3/models/IOffer";

interface IParamsCalculateOffers {
  deviceModelId?: number;
  deviceVariantId?: number | null;
  price: number;
  downPayment?: number | null;
}

export const getUserIsApproved = async (
  cartTag: string
): Promise<AxiosResponse<{ code: number; message: string }>> => {
  return await jwtApiClient.get(M3_API(cartTag).IS_USER_APPROVED);
};

export const getOfferSummary = async (
  cartTag: string
): Promise<AxiosResponse<IOfferSummary>> => {
  return await jwtApiClient.get(M3_API(cartTag).GET_OFFER_SUMMARY);
};

export const getAvailableOffers = async (
  cartTag: string
): Promise<AxiosResponse<IAvailableOffersResponse>> => {
  return await jwtApiClient.get(M3_API(cartTag).AVAILABLE_OFFERS);
};

export const calculateOffers = async (
  cartTag: string,
  price: number,
  deviceModelId?: number,
  deviceVariantId?: number | null,
  downPayment?: number | null | undefined
): Promise<AxiosResponse<IOffer>> => {
  const params: IParamsCalculateOffers = {
    deviceModelId,
    deviceVariantId,
    price,
  };
  if (typeof downPayment !== "undefined" && downPayment !== null) {
    params.downPayment = downPayment;
  }
  return await jwtApiClient.get(M3_API(cartTag).CALCULATE_OFFERS, {
    params,
  });
};

export const setOfferData = async (
  cartTag: string,
  retailPrice: number,
  downPayment: number,
  months: number,
  deviceModelId?: number,
  deviceVariantId?: number | null
): Promise<AxiosResponse<IOffer>> => {
  return await jwtApiClient.post(M3_API(cartTag).SET_OFFER_DATA, {
    deviceModelId,
    deviceVariantId,
    retailPrice,
    downPayment,
    term: months,
  });
};
